import { c as _c } from "react/compiler-runtime";
import { css, cva, cx } from '@repo/pandacss/css';
import Link from 'next/link';
import type { ReactNode } from 'react';
import { FINDER_ENTRY_PATH } from '@/shared/config/funnel/flowConstants';
import type { GoalOption } from '../config';
type Variant = 'button' | 'link';
type Size = 'medium' | 'small';
type FlowCtaProps = {
  primaryGoal?: GoalOption;
  trkLocation?: string;
  variant?: Variant;
  size?: Size;
  className?: string;
  children: ReactNode;
};
function buildFlowHref(primaryGoal: GoalOption, trkLocation?: string): string {
  const isGoal = primaryGoal !== '';
  const base = isGoal ? `${FINDER_ENTRY_PATH}/${primaryGoal}` : FINDER_ENTRY_PATH;
  if (!trkLocation) return base;
  const params = new URLSearchParams({
    trk_location: trkLocation
  });
  return `${base}?${params.toString()}`;
}
const buttonRecipe = cva({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    w: '[100%]',
    bg: 'greens.main',
    color: 'common.white',
    border: 'none',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'all',
    _hover: {
      bg: 'greens.dark'
    },
    _active: {
      transform: '[scale(0.99)]'
    }
  },
  variants: {
    size: {
      medium: {
        textStyle: 'accent',
        px: '3',
        py: '3'
      },
      small: {
        textStyle: 'accent.small',
        rounded: '[4px]',
        h: '[2.5rem]',
        px: '3'
      }
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});
const linkStyles = css({
  color: 'blues.main',
  textDecoration: 'underline',
  _hover: {
    textDecoration: 'none'
  }
});
export function FlowCta(t0) {
  const $ = _c(15);
  const {
    primaryGoal: t1,
    trkLocation,
    variant: t2,
    size: t3,
    className,
    children
  } = t0;
  const primaryGoal = t1 === undefined ? "" : t1;
  const variant = t2 === undefined ? "button" : t2;
  const size = t3 === undefined ? "medium" : t3;
  let t4;
  if ($[0] !== primaryGoal || $[1] !== trkLocation) {
    t4 = buildFlowHref(primaryGoal, trkLocation);
    $[0] = primaryGoal;
    $[1] = trkLocation;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const href = t4;
  let T0;
  let t5;
  let t6;
  if ($[3] !== className || $[4] !== href || $[5] !== size || $[6] !== variant) {
    const styles = variant === "button" ? buttonRecipe({
      size
    }) : linkStyles;
    T0 = Link;
    t5 = href;
    t6 = cx(styles, className);
    $[3] = className;
    $[4] = href;
    $[5] = size;
    $[6] = variant;
    $[7] = T0;
    $[8] = t5;
    $[9] = t6;
  } else {
    T0 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== T0 || $[11] !== children || $[12] !== t5 || $[13] !== t6) {
    t7 = <T0 href={t5} className={t6}>{children}</T0>;
    $[10] = T0;
    $[11] = children;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}